import {DIR_LTR, NAV_TYPE_SIDE, SIDE_NAV_LIGHT,} from 'constants/ThemeConstant';
import {env} from './EnvironmentConfig';

export const APP_NAME = 'Easy Shop Tracker';
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';
export const DOC_PREFIX_PATH = '/docs';
export const APP_ERROR_PATH = '/error';
export const APP_NOT_FOUND_PATH = '/404';

const detectTheme = () => {
  const user = localStorage.getItem('user')
    ? JSON.parse(localStorage.getItem('user'))
    : {
        name: null,
        avatar: null,
        id: null,
        dark_theme: false,
      };

  if (user.dark_theme) {
    return 'dark';
  } else {
    return 'light';
  }
};

export const THEME_CONFIG = {
  navCollapsed: false,
  sideNavTheme: SIDE_NAV_LIGHT,
  locale: 'en',
  navType: NAV_TYPE_SIDE,
  topNavColor: '#3e82f7',
  headerNavColor: '',
  mobileNav: false,
  currentTheme: detectTheme(),
  direction: DIR_LTR,
};
